import type { RiskType } from "@unbox/api";
import { Eye, Recording02 } from "@untitledui/icons";
import { Transcript } from "@/components/icons/transcript.tsx";

// videos.videoUrl holds the media URL, not the post's share link, so the TikTok watch
// link is composed from the creator handle and video id — stripping the CID-/VID- prefixes
// the stored ids carry. Returns an empty string without a creator handle, since the link
// can't be formed and a bare video id would resolve to the wrong path.
export const buildTikTokVideoUrl = (creatorId: string | null | undefined, videoId: string): string =>
  creatorId ? `https://www.tiktok.com/@${creatorId.replace("CID-", "")}/video/${videoId.replace("VID-", "")}` : "";

export const getRiskTypeIcon = (riskType: RiskType, className = "w-[18px] h-[18px] text-secondary") => {
  switch (riskType) {
    case "visual":
      return <Eye className={className} />;
    case "audio":
      return <Recording02 className={className} />;
    case "text":
      return <Transcript className={className} />;
  }
};
